import axios from "axios";
import store from "../stores/store";

export const client = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json',
    },
})

client.interceptors.request.use(
  (config) => {
    const token = store.state.token;

    if (token) {
      config.headers["Authorization"] = 'Bearer ' + token
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
)

client.interceptors.response.use(function (response) {
  return response;
}, function (err) {
  if (err.response.status === 401) {
    store.dispatch('logout')
  }
  return Promise.reject(err)
})
